var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgExternalLink = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 16,
  height: 16,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M3.333 4.667a.667.667 0 0 0-.666.666v7.334a.667.667 0 0 0 .666.666h7.334a.667.667 0 0 0 .666-.666v-4a.667.667 0 0 1 1.334 0v4a2 2 0 0 1-2 2H3.333a2 2 0 0 1-2-2V5.333a2 2 0 0 1 2-2h4a.667.667 0 0 1 0 1.334zM9.333 2c0-.368.299-.667.667-.667h4c.368 0 .667.299.667.667v4a.667.667 0 1 1-1.334 0V2.667H10A.667.667 0 0 1 9.333 2",
  clipRule: "evenodd"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M14.471 1.529c.26.26.26.682 0 .942L7.138 9.805a.667.667 0 1 1-.943-.943l7.334-7.333c.26-.26.682-.26.942 0",
  clipRule: "evenodd"
})));
export default SvgExternalLink;